import { TicketComponent } from './TicketComponent';
import {
  DecoratorNode,
  NodeKey,
  SerializedLexicalNode,
  Spread,
  $applyNodeReplacement,
} from 'lexical';
import React from 'react';

export type SerializedTicketNode = Spread<
  {
    ticketId: string;
    showTitle: boolean;
  },
  SerializedLexicalNode
>;

export function $createTicketNode(
  ticketId: string,
  showTitle: boolean = false,
): TicketNode {
  const ticketNode = new TicketNode(ticketId, showTitle);
  return $applyNodeReplacement(ticketNode);
}

export class TicketNode extends DecoratorNode<React.JSX.Element> {
  __ticketId: string;
  __showTitle: boolean;

  static getType(): string {
    return 'ticket';
  }

  static clone(node: TicketNode): TicketNode {
    return new TicketNode(node.__ticketId, node.__showTitle, node.__key);
  }

  constructor(ticketId: string, showTitle: boolean = false, key?: NodeKey) {
    super(key);
    this.__ticketId = ticketId;
    this.__showTitle = showTitle;
  }

  exportJSON(): SerializedTicketNode {
    return {
      ticketId: this.__ticketId,
      showTitle: this.__showTitle,
      type: 'ticket',
      version: 1,
    };
  }

  static importJSON(serializedNode: SerializedTicketNode): TicketNode {
    const { ticketId, showTitle } = serializedNode;
    const node = $createTicketNode(ticketId, showTitle);
    return node;
  }

  createDOM(): HTMLElement {
    return document.createElement('span');
  }

  updateDOM(): false {
    return false;
  }

  decorate(): React.JSX.Element {
    return (
      <TicketComponent
        ticketId={this.__ticketId}
        showTitle={this.__showTitle}
        nodeKey={this.getKey()}
      />
    );
  }

  getTicketId(): string {
    return this.__ticketId;
  }

  getShowTitle(): boolean {
    return this.__showTitle;
  }

  setTicketId(ticketId: string): void {
    const writable = this.getWritable();
    writable.__ticketId = ticketId;
  }

  setShowTitle(showTitle: boolean): void {
    const writable = this.getWritable();
    writable.__showTitle = showTitle;
  }
}
